'use strict';

define([], function () {
  /*
  * Columbo Constants
  * ====================
  *
  *  All of the constants used throughout the
  *  Columbo tracking service are stored here.
  *
   */
  var Constants = {
    columboVersion: '2.1',
    chaseSessionKey: 'chumewe_sess',
    chaseUserKey: 'chumewe_user',
    gtmEventNameAppend: '_Columbo'
  };

  return Constants;
});
//# sourceMappingURL=columbo-constants.js.map
